import { Component, Input } from '@angular/core'
import { BaseSiteService } from '@spartacus/core'
import { map, take } from 'rxjs/operators'
import { MbConstants } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-payment-methods',
  templateUrl: './mb-payment-methods.component.html',
})
export class MbPaymentMethodsComponent {

  @Input()
  addMargin: boolean = false

  state$ = this.baseSiteService.getActive().pipe(take(1))
    .pipe(
      map((activeBaseSite) => ({
          isForUs: activeBaseSite === this.constants.MB_BASE_SITE_NO_COUNTRY_KEY + 'US' || activeBaseSite === this.constants.MB_BASE_SITE_NO_COUNTRY_KEY + 'CA',
          isForAu: activeBaseSite === this.constants.MB_BASE_SITE_NO_COUNTRY_KEY + 'AU'
        })))
  constants = MbConstants

  constructor (protected baseSiteService: BaseSiteService) { }
}
